"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.space = exports.size = exports.color = void 0;
exports.color = {
  bC: true,
  bgC: true,
  c: true
};
exports.size = {
  h: true,
  maxH: true,
  maxW: true,
  minH: true,
  minW: true,
  w: true
};
exports.space = {
  g: true,
  gX: true,
  gY: true,
  m: true,
  mB: true,
  mL: true,
  mR: true,
  mT: true,
  mX: true,
  mY: true,
  p: true,
  pB: true,
  pL: true,
  pR: true,
  pT: true,
  pX: true,
  pY: true,
  sX: true,
  sY: true
};